import { useLocation, useHistory } from 'react-router-dom';

export function useQueryStringsHandover(chainQueryStrings: string[]) {
  const history = useHistory();
  const { search } = useLocation();

  const currentSearchParams = new URLSearchParams(search)
  const chainParams:any = new Object


  currentSearchParams.forEach((v,k)=> {
    chainParams[k] = v
  })

  const pushHistoryWithQueryStrings = (path: string) => {
    const url = new URL(`http://example.com${path}`)
    const newSearchParams = url.searchParams

    chainQueryStrings.forEach((k) => {
      if (chainParams[k]) newSearchParams.append(k, chainParams[k])
    })

    // Line 0:  Parsing error: DeprecationError: 'originalKeywordKind' has been deprecated since v5.0.0 and can no longer be used. Use 'identifierToKeywordKind(identifier)' instead
    // 意味不明なエラーによる dev server 起動失敗の回避として @ts-ignore を記載
    if (Array.from(newSearchParams).length > 0) {
      history.push(`${url.pathname}?${newSearchParams.toString()}`)
      
    } else {
      history.push(path);
    }
  }

  return pushHistoryWithQueryStrings
};